import React from "react";

const DashboardFooter = () => {
  return (
    <footer className="bg-gray-100 border-t border-gray-200 py-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-sm text-gray-500">
          © 2025 RecruAI. Built with ❤️ for better recruitment.
        </div>
      </div>
    </footer>
  );
};

export default DashboardFooter;
